import PocketBase from 'pocketbase'
import type { TypedPocketBase } from '~~/pocketbase-types'

export default defineNuxtPlugin({
  name: 'pocketbase',
  async setup(nuxtApp) {
    const { pbUrl } = useRuntimeConfig().public
    const pb = new PocketBase(pbUrl) as TypedPocketBase

    const cookie = useCookie('pb_auth', {
      path: '/',
      secure: true,
      sameSite: 'strict',
      httpOnly: false, // change to "true" if you want only server-side access
      maxAge: 604800,
    })

    // load the store data from the cookie value
    pb.authStore.save(cookie.value?.token || '', cookie.value?.record || null)

    // 2. Sync SDK changes back to the Nuxt cookie
    pb.authStore.onChange(() => {
      if (pb.authStore.isValid) {
        cookie.value = {
          token: pb.authStore.token,
          record: pb.authStore.record, // Changed from model to record
        }
      } else {
        cookie.value = null
      }
    })


    if (pb.authStore.isValid && pb.authStore.record) {
      // Grab the collection name dynamically (e.g., '_superusers' or 'users')
      const collectionName = pb.authStore.record.collectionName

      try {
        await pb.collection(collectionName).authRefresh()
      } catch (_) {
        // If the refresh fails (token expired, user deleted), clear the store
        pb.authStore.clear()
      }
    }

    pb.autoCancellation(false)
    if (!pb.authStore.isValid) {
      pb.authStore.clear()
    }

    return {
      provide: { pb: pb as TypedPocketBase },
    }
  },
})
